export const getPulseTargetBaseUrl = (): string => window.location.origin;
